import { Button, IconClose } from '@odekoteam/doppio';
import { useState } from 'react';
import { Box, Flex, Heading, Image, ThemeUICSSObject } from 'theme-ui';

import pageStructureReference from '@/assets/images/page-structure-reference.png';
import Modal from '@/components/Modal';

export function ModalReference({
  triggerWrapperSx,
  triggerVariant = 'tertiary',
}: {
  triggerWrapperSx?: ThemeUICSSObject;
  triggerVariant?: 'ghost' | 'tertiary';
}) {
  const [referenceModalVisible, setReferenceModalVisible] = useState(false);

  return (
    <div sx={triggerWrapperSx}>
      <Button
        size="small"
        variant={triggerVariant}
        onPress={() => setReferenceModalVisible(true)}
      >
        Page Structure Reference
      </Button>
      <Modal
        contentStyle={{
          p: 0,
          width: '84vw',
          height: '84vh',
          display: 'flex',
          maxWidth: '84vw',
          overflow: 'hidden',
          flexDirection: 'column',
        }}
        visible={referenceModalVisible}
      >
        <Flex
          sx={{
            py: 3,
            px: 4,
            alignItems: 'center',
            borderBottom: '1px solid',
            justifyContent: 'space-between',
            borderBottomColor: 'secondaryHighlight',
          }}
        >
          <Heading variant="headingMd">Homepage Structure Preview</Heading>
          <Button
            variant="ghost"
            iconLeft={<IconClose />}
            onPress={() => setReferenceModalVisible(false)}
          />
        </Flex>
        <Box sx={{ flex: 1, overflowY: 'auto' }}>
          <Image alt="Page structure reference" src={pageStructureReference} />
        </Box>
      </Modal>
    </div>
  );
}
